export default __webpack_public_path__ + "static/media/arrowLeftBlack.8a0c78dd.svg";